import ViewModel3D from './view-model-3d';
import Area3D from './area-3d';
import Wall3D from './wall-3d';
import Teleport3D from './teleport-3d';

export {
    ViewModel3D,
    Area3D,
    Wall3D,
    Teleport3D
}

export default {
    ViewModel3D,
    Area3D,
    Wall3D,
    Teleport3D
}